import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, deepPurpleMui, greyMui } from "@ryde/theme";

export const SupplierPriceRatesPasswordWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "supplier-price-rates-password-wrapper",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;

  .login-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .login-title {
    font-size: 18px;
    font-weight: 600;
    color: ${greyMui._800};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      border-top: 1px dotted ${greyMui._400};
    }
  }

  .password-field-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .password-label {
    font-size: 14px;
    font-weight: 500;
    color: ${greyMui._800};
  }

  .password-input {
    padding: 12px;
    border: 1px solid ${greyMui._400};
    border-radius: 4px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${deepPurpleMui._500};
    }
  }

  .password-gate-obfuscated {
    -webkit-text-security: disc;
  }

  .password-hint {
    font-size: 12px;
    color: ${greyMui._600};
    margin: 0;

    a {
      color: ${blueMui._500};
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
